import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedOptions: [],
};

const quizzesSlice = createSlice({
  name: "quizzes",
  initialState,
  reducers: {
    selectedQuizOptions: (state, action) => {
      state.selectedOptions.push(action.payload);
    },
    deselectedQuizOptions: (state, action) => {
      const { key, value } = action.payload;
      state.selectedOptions = state.selectedOptions.filter((obj) => {
        const [k, v] = Object.entries(obj)[0];
        return k != key || v != value;
      });
    },
  },
});

export const { selectedQuizOptions, deselectedQuizOptions } =
  quizzesSlice.actions;
export default quizzesSlice.reducer;
